import {Component} from '@angular/core';
import {AbstractComponent} from '../abstract.component';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ShareModalComponent} from "@components";
import {Input} from "@angular/core";
import {EventItem, Lookups} from "@model";

@Component({
    selector: 'app-save-share',
    templateUrl: './save-share.component.html',
    styleUrls: ['./save-share.component.scss'],
    standalone: false
})
export class SaveShareComponent extends AbstractComponent {
  @Input('eventDetails') event?: EventItem;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() isPreviewComponent?: boolean;
  @Input() isXsComponent?: boolean = false;

  constructor(private modalService: NgbModal) {
    super();
  }

  openShareModal() {
    const modalRef: NgbModalRef = this.modalService.open(ShareModalComponent, {
      centered: true,
      windowClass: 'share-modal'
    });
    modalRef.componentInstance.languages = this.languages;
    modalRef.componentInstance.eventItem = this.event;
  }
}
